import React from 'react';

import { FieldValuesQuery } from '~src/httpClient/resources/FieldValuesQuery';
import { GroupHeader } from '~src/spacesPlatform/components/filterPanel/GroupHeader';
import { RadioButtonGroupFilter } from '~src/spacesPlatform/components/filterPanel/RadioButtonGroupFilter';
import { SelectDropdownFilter } from '~src/spacesPlatform/components/filterPanel/SelectDropdownFilter';
import { TextFilter } from '~src/spacesPlatform/components/filterPanel/TextFilter';
import { TypeaheadDropdownFilter } from '~src/spacesPlatform/components/filterPanel/TypeaheadDropdownFilter';

import { CheckBoxFilter } from './CheckBoxFilter';
import { DatePickerFilter } from './DatePickerFilter';
import { IFilterControl } from './FilterPanel';


interface SectionProps {
  readonly sectionHeaderText: string;
  readonly testId: string;
  readonly filters: IFilterControl[];
  readonly shouldClear: boolean;
  readonly getFieldValueQuery?: (filterField: string) => FieldValuesQuery;
}

export function FilterPanelSection(props: SectionProps) {
  return <div data-tb-test-id={props.testId+'-FilterPanelSection'}>
    <GroupHeader text={props.sectionHeaderText} />
    {(props.filters ?? []).map(filter =>
      getFilter(filter, props.shouldClear, props.getFieldValueQuery))
    }
  </div>;
}

function getFilter(
    filter: IFilterControl,
    shouldClear: boolean,
    getFieldValueQuery?: (filterField: string) => FieldValuesQuery) {

  switch (filter.definition.type) {
    case 'boolean':
      return <CheckBoxFilter
        key={filter.definition.name}
        filterControl={filter}
        shouldClear={shouldClear}
      />;
    case 'date':
      return <DatePickerFilter
        key={filter.definition.name}
        filterControl={filter}
        shouldClear={shouldClear}
      />;
    case 'radio':
      return <RadioButtonGroupFilter
        key={filter.definition.name}
        filterControl={filter}
        shouldClear={shouldClear}
      />;
    case 'select':
      return <SelectDropdownFilter
        key={filter.definition.name}
        filterControl={filter}
        shouldClear={shouldClear}
        showContentCount={filter.definition.showCounts}
      />;
    case 'text':
      return <TextFilter
        key={filter.definition.name}
        filterControl={filter}
        shouldClear={shouldClear}
      />;
    case 'typeahead':
      return <TypeaheadDropdownFilter
        key={filter.definition.name}
        filterControl={filter}
        getFieldValueQuery={getFieldValueQuery}
        shouldClear={shouldClear}
      />;
    default:
      return null;

  }
}
